import { Stack, Typography, useTheme } from "@mui/material";
import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BuildingSavingsAdditionalFields } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/BuildingSavingsAdditionalFields";
import { BuildingSavingsBasicFields } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/BuildingSavingsBasicFields";
import { BuildingSavingsContractFields } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/BuildingSavingsContractFields";
import type {
	BuildingSavingsEditFormInput,
	BuildingSavingsEditFormOutput,
} from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormSchema";
import {
	CONTRACT_REQUIRED_MINIMUM_FIELDS,
	getContractRequiredMinimumMessage,
} from "web_myplann/Portfolio/Forms/ContractShared/contractRequiredMinimum";
import { RequiredMinimumMessage } from "web_myplann/Portfolio/PortfolioShared/RequiredMinimumMessage";

type BuildingSavingsEditFormFieldsProps = {
	control: Control<
		BuildingSavingsEditFormInput,
		unknown,
		BuildingSavingsEditFormOutput
	>;
	disableKeyFields: boolean;
};

export const BuildingSavingsEditFormFields = ({
	control,
	disableKeyFields,
}: BuildingSavingsEditFormFieldsProps) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<>
			<BuildingSavingsBasicFields
				control={control}
				namePlaceholder={t(
					Resources.Portfolio.AddBuildingSavings.Placeholders.nameEdit,
				)}
				contractNumberPlaceholder={t(
					Resources.Portfolio.AddBuildingSavings.Placeholders
						.contractNumberEdit,
				)}
				disableKeyFields={disableKeyFields}
			/>
			<RequiredMinimumMessage
				control={control}
				fields={CONTRACT_REQUIRED_MINIMUM_FIELDS}
				message={getContractRequiredMinimumMessage(
					t,
					Resources.Portfolio.AddBuildingSavings.Fields,
				)}
			/>

			<Typography variant="sectionLabel">
				{t(Resources.Portfolio.AddBuildingSavings.Sections.values)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<BuildingSavingsContractFields control={control} />
			</Stack>

			<BuildingSavingsAdditionalFields
				control={control}
				disableKeyFields={disableKeyFields}
			/>
		</>
	);
};
